export default __webpack_public_path__ + "static/media/btn-vr-play.066ef39d.png";